import { Modal, Image, Empty, Tooltip } from 'antd'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import { SignTitle } from '@/components'
import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import { t } from '@/i18n'

export const Particulars = props => {
  const { visible, close } = props
  const [content, setContent] = useState('')
  useEffect(() => {
    if (visible?.data?.email_content) {
      var b = /<a([\s]+|[\s]+[^<>]+[\s]+)href=(\"([^<>"\']*)\"|\'([^<>"\']*)\')[^<>]*>/gi
      let str = visible?.data?.email_content?.replace(b, '<span>')
      str = str?.replace(/<\/a>/gi, '</span>')
      setContent(str)
    }
  }, [visible])
  return (
    <Create
      title={<SignTitle show>{t('模板详情')}</SignTitle>}
      visible={visible.visible}
      onCancel={() => {
        close()
      }}
      width={700}
      footer={[]}
    >
      <div style={{ height: '500px' }}>
        <Scrollbars>
          <div className="main">
            <div className="title">{t('模板名称:')}</div>
            <div className="text">{visible?.data?.email_name}</div>
          </div>
          <div className="main">
            <div className="title">{t('邮件类型:')}</div>
            {visible?.data?.email_type === '恶意附件' && (
              <div className="accessory">{t('恶意附件')}</div>
            )}
            {visible?.data?.email_type === '钓鱼链接' && (
              <div className="link">{t('钓鱼链接')}</div>
            )}
          </div>
          <div className="main">
            <div className="title">{t('发件人昵称:')}</div>
            <div className="text">{visible?.data?.email_sender}</div>
          </div>
          <div className="main">
            <div className="title">{t('邮件主题:')}</div>
            <div className="text">{visible?.data?.email_subject}</div>
          </div>
          <div className="main">
            <div className="title">{t('邮件正文:')}</div>
            <div className="email-main">
              <Scrollbars>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
              </Scrollbars>
            </div>
          </div>
          {visible?.data?.email_link && (
            <div className="main">
              <div className="title">{t('链接名称:')}</div>
              <div className="text">{visible?.data?.email_link || '-'}</div>
            </div>
          )}
          {visible?.data?.email_attck && (
            <div className="main">
              <div className="title">ATT&CK:</div>
              <div className="text">
                {visible?.data?.email_attck?.map((item, index) => (
                  <div key={index} style={{ marginBottom: 16 }}>
                    <a target="_blank" href={item.url} rel="noopener noreferrer">
                      {item.name}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* {resList?.map(item => {
               const reg3 = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
               if (reg3.exec(item) != null) {
                 var content = RegExp.$2
               }
               return (
                 <div className="main">
                   <Tooltip placement="top" title={content}>
                     <div className="title">{content}</div>
                   </Tooltip>
                   <p>{'{URL}'}</p>
                 </div>
               )
             })} */}
          <div className="best">
            <p className="best-text">{visible?.data?.email_type}</p>
          </div>
          {visible?.data?.email_type === '钓鱼链接' && (
            <div className="main">
              <div className="title">{t('模板名称:')}</div>
              <div className="text">{visible?.data?.page_name}</div>
            </div>
          )}
          {visible?.data?.email_type === '恶意附件' && (
            <div className="main">
              <div className="title">{t('附件:')}</div>
              <div className="text">{visible?.data?.attach_file_name}</div>
            </div>
          )}
          {visible?.data?.email_type === '钓鱼链接' && (
            <div className="main">
              <div className="title">{t('钓鱼页类型:')}</div>
              {visible?.data?.page_type === '钓鱼页' && (
                <div className="phishing">{t('钓鱼页')}</div>
              )}
              {visible?.data?.page_type === '钓鱼页+信息收集' && (
                <div className="phishing-msg">{t('钓鱼页+信息收集')}</div>
              )}
            </div>
          )}
          {visible?.data?.email_type === '钓鱼链接' && (
            <div className="main">
              <div className="title">{t('重定向页面:')}</div>
              <a
                rel="noopener noreferrer"
                target={visible?.data?.url ? '_blank' : ''}
                href={visible?.data?.url ? `${visible?.data?.url}` : 'javaScript:;'}
              >
                {visible?.data?.url || '-'}
              </a>
            </div>
          )}
          {visible?.data?.email_type === '钓鱼链接' && (
            <>
              <div className="main">
                <div className="title" />
                <Image
                  width={200}
                  fallback={`${
                    process.env.NODE_ENV === 'dev' ? '/api' : ''
                  }/static/default/phishPage.png`}
                  src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${
                    visible?.data?.page_cover
                  }`}
                />
              </div>
              {visible?.data?.page_attck && (
                <div className="main">
                  <div className="title">ATT&CK:</div>
                  <div className="text">
                    {visible?.data?.page_attck?.map((item, index) => (
                      <div key={index} style={{ marginBottom: 16 }}>
                        <a target="_blank" href={item.url} rel="noopener noreferrer">
                          {item.name}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          {visible?.data?.email_type === '恶意附件' && (
            <>
              <div className="main">
                <div className="title">{t('附件类型:')}</div>
                {visible?.data?.attach_type === 1 && <span className="accessory-exe">EXE</span>}
                {visible?.data?.attach_type === 2 && <span className="accessory-doc">DOC/X</span>}
                {visible?.data?.attach_type === 3 && <span className="accessory-xls">XLS/X</span>}
                {visible?.data?.attach_type === 4 && <span className="accessory-ppt">PPT/X</span>}
                {visible?.data?.attach_type === 5 && <span className="accessory-pdf">PDF</span>}
                {visible?.data?.attach_type === 6 && <span className="accessory-rtf">RTF</span>}
              </div>
              {visible?.data?.attachment_attck && (
                <div className="main">
                  <div className="title">ATT&CK:</div>
                  <div className="text">
                    {visible?.data?.attachment_attck?.map((item, index) => (
                      <div key={index} style={{ marginBottom: 16 }}>
                        <a target="_blank" href={item.url} rel="noopener noreferrer">
                          {item.name}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </Scrollbars>
      </div>
    </Create>
  )
}

const Create = styled(Modal)`
  height: 400px;
  .main {
    display: flex;
    margin-bottom: 24px;
    .title {
      width: 105px;
      text-align: left;
      color: #86909c;
      //margin-right: 32px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .accessory-exe {
    padding: 4px 8px;
    background: rgba(179, 89, 59, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #b3593b;
  }
  .accessory-doc {
    padding: 4px 8px;
    background: rgba(0, 55, 113, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #003771;
  }
  .accessory-xls {
    padding: 4px 8px;
    background: rgba(97, 164, 157, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #61a49d;
  }
  .accessory-ppt {
    padding: 4px 8px;
    background: rgba(66, 106, 103, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #426a67;
  }
  .accessory-pdf {
    padding: 4px 8px;
    background: #f5d9da;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #d38788;
  }
  .accessory-rtf {
    padding: 4px 8px;
    background: rgba(222, 118, 87, 0.2);
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #de7657;
  }
  .best {
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    justify-content: space-between;
    &::after {
      content: '';
      display: inline-block;
      border-top: 1px solid #eaedf1;
      width: 0;
      flex: 1;
    }
    .best-text {
      margin: 0 10px;
      font-size: 16px;
    }
    &::before {
      content: '';
      display: inline-block;
      border-top: 1px solid #eaedf1;
      width: 24px;
    }
  }
  .email-main {
    width: 500px;
    background-color: #f7f8fa;
    border-radius: 6px;
    min-height: 300px;
    padding: 8px 12px;
  }

  .link {
    padding: 4px 8px;
    background: #ebe9ff;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #645aff;
  }
  .phishing-msg {
    background: #e0f2f2;
    border-radius: 4px;
    display: inline-block;
    padding: 4px 8px;
    text-align: center;
    font-size: 12px;
    color: #65bdc0;
  }
  .phishing {
    padding: 4px 8px;
    background: #d5e4ff;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #2973ff;
  }
`
